package com.patronat.top.client.deeplink

import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.emitAll
import kotlinx.coroutines.flow.flow

object ClientDeepLinks {
    private const val WebBaseUrl = "https://topreview.com.ua"
    private const val VenueWebPrefix = "$WebBaseUrl/venues/"
    private const val VenueSchemePrefix = "top://venues/"
    private const val VenueLegacySchemePrefix = "top://venue/"

    private val venueIdEvents = MutableSharedFlow<String>(extraBufferCapacity = 1)
    private var pendingVenueId: String? = null

    fun venueUrl(venueId: String): String {
        return "$VenueWebPrefix$venueId"
    }

    fun open(rawUrl: String) {
        val venueId = rawUrl.parseVenueId() ?: return
        if (venueIdEvents.subscriptionCount.value == 0) {
            pendingVenueId = venueId
        }
        venueIdEvents.tryEmit(venueId)
    }

    fun observeVenueIds(): Flow<String> = flow {
        pendingVenueId?.let { venueId ->
            pendingVenueId = null
            emit(venueId)
        }
        emitAll(venueIdEvents)
    }

    private fun String.parseVenueId(): String? {
        val url = trim()
        val rawVenueId = when {
            url.startsWith(VenueWebPrefix) -> url.removePrefix(VenueWebPrefix)
            url.startsWith("https://www.topreview.com.ua/venues/") -> url.removePrefix("https://www.topreview.com.ua/venues/")
            url.startsWith(VenueSchemePrefix) -> url.removePrefix(VenueSchemePrefix)
            url.startsWith(VenueLegacySchemePrefix) -> url.removePrefix(VenueLegacySchemePrefix)
            "/venues/" in url -> url.substringAfter("/venues/")
            else -> return null
        }

        return rawVenueId
            .substringBefore('?')
            .substringBefore('#')
            .trim('/')
            .takeIf(String::isNotBlank)
    }
}

fun clientVenueDeepLink(venueId: String): String {
    return ClientDeepLinks.venueUrl(venueId)
}

fun openClientDeepLink(rawUrl: String) {
    ClientDeepLinks.open(rawUrl)
}
